export const postDSPMesage = () => {
    try {
      if (
        // @ts-ignore
        window.AndroidInterface &&
        // @ts-ignore
        typeof window.AndroidInterface.postMessage === "function"
      ) {
        // @ts-ignore
        window.AndroidInterface.postMessage("DSP");
      }
     // @ts-ignore
     window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("DSP");     
     // @ts-ignore
     window?.ReactNativeWebView?.postMessage("DSP")
     // @ts-ignore
     window?.top?.postMessage("DSP")
     } catch (e) {
       console.warn("postDSPMessage failed", e);
     }
  };

